import { useEffect, useState } from "react";
import { getHiringCompanyWithJobCount } from "@endpoints/recruiter.service";

export interface HiringCompanyWithJobCount {
  hiringCompany: { _id: string; companyName: string };
  totalJobs: number;
}

export const useHiringCompanies = () => {
  const [hiringCompanies, setHiringCompanies] = useState<
    HiringCompanyWithJobCount[]
  >([]);

  useEffect(() => {
    let isCancelled = false;
    getHiringCompanyWithJobCount({ page: 1, limit: 20 })
      .then(({ data, success }) => {
        if (success && !isCancelled) setHiringCompanies(data ?? []);
      })
      .catch(() => {});
    return () => {
      isCancelled = true;
    };
  }, []);

  return hiringCompanies;
};
